import { render, staticRenderFns } from "./choose-one-click.vue?vue&type=template&id=ca00d6cc&scoped=true"
import script from "./choose-one-click.vue?vue&type=script&lang=js"
export * from "./choose-one-click.vue?vue&type=script&lang=js"
import style0 from "./choose-one-click.vue?vue&type=style&index=0&id=ca00d6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca00d6cc",
  null
  
)

export default component.exports